// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HuddleTaskRow-module__row___EAa7E {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 20px;
  transition: background-color 0.15s;
}

.HuddleTaskRow-module__checkbox___VIv8e {
  flex-shrink: 0;
  margin-top: 2px;
  width: 26px;
  height: 26px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #a1a1aa;
  border-radius: 6px;
  color: #ffffff;
  background: #ffffff;
  cursor: pointer;
}

.HuddleTaskRow-module__checkbox___VIv8e:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.HuddleTaskRow-module__checkboxChecked___nBp1w {
  border-color: #18181b;
  background: #18181b;
}

.HuddleTaskRow-module__checkmark___dsfs5 {
  flex-shrink: 0;
}

.HuddleTaskRow-module__linkedIcon___wAY2k {
  flex-shrink: 0;
  margin-top: 2px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a1a1aa;
}

.HuddleTaskRow-module__linkedIconGlyph___w3noC {
  width: 14px;
  height: 14px;
}

.HuddleTaskRow-module__label___NKZtt {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: -4px 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  padding: 4px 0;
  text-align: left;
  cursor: pointer;
  font: inherit;
}

.HuddleTaskRow-module__labelText___W5MgC {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.HuddleTaskRow-module__openChevron___C2Fvu {
  flex-shrink: 0;
  color: #a1a1aa;
}

.HuddleTaskRow-module__title___F6hIR {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 17px;
  line-height: 1.4286;
  font-weight: 600;
  color: #18181b;
}

.HuddleTaskRow-module__titleDone___nidUi {
  color: #a1a1aa;
}

.HuddleTaskRow-module__descriptionDone___dwbGQ {
  color: #a1a1aa;
}

.HuddleTaskRow-module__rowOpen___u3X8i {
  background: #fafafa;
}

.HuddleTaskRow-module__titleUrgent___FVUpg {
  color: #991b1b;
}

.HuddleTaskRow-module__description___JZQWd {
  margin-top: 2px;
  font-size: 14px;
  line-height: 1.4286;
  color: #3f3f46;
}

.HuddleTaskRow-module__facts___jCn_q {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
  font-size: 14px;
  line-height: 1.4286;
  color: #71717a;
}

.HuddleTaskRow-module__dueUrgent___C6gjR {
  font-weight: 600;
  color: #991b1b;
}

.HuddleTaskRow-module__actions___BVo7d {
  flex-shrink: 0;
  align-self: center;
  display: flex;
  align-items: center;
  gap: 8px;
}

.HuddleTaskRow-module__assignButton___gTzBO {
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #18181b;
  cursor: pointer;
  white-space: nowrap;
}

.HuddleTaskRow-module__assignButton___gTzBO:hover:not(:disabled) {
  background: #f4f4f5;
}

.HuddleTaskRow-module__assignButton___gTzBO:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/HuddleTaskRow/HuddleTaskRow.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,kCAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF","sourcesContent":[".row {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 16px 20px;\n  transition: background-color 0.15s;\n}\n\n.checkbox {\n  flex-shrink: 0;\n  margin-top: 2px;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #a1a1aa;\n  border-radius: 6px;\n  color: #ffffff;\n  background: #ffffff;\n  cursor: pointer;\n}\n\n.checkbox:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.checkboxChecked {\n  border-color: #18181b;\n  background: #18181b;\n}\n\n.checkmark {\n  flex-shrink: 0;\n}\n\n.linkedIcon {\n  flex-shrink: 0;\n  margin-top: 2px;\n  width: 26px;\n  height: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #a1a1aa;\n}\n\n.linkedIconGlyph {\n  width: 14px;\n  height: 14px;\n}\n\n.label {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: -4px 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  padding: 4px 0;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n}\n\n.labelText {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.openChevron {\n  flex-shrink: 0;\n  color: #a1a1aa;\n}\n\n.title {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 17px;\n  line-height: 1.4286;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.titleDone {\n  color: #a1a1aa;\n}\n\n.descriptionDone {\n  color: #a1a1aa;\n}\n\n.rowOpen {\n  background: #fafafa;\n}\n\n.titleUrgent {\n  color: #991b1b;\n}\n\n.description {\n  margin-top: 2px;\n  font-size: 14px;\n  line-height: 1.4286;\n  color: #3f3f46;\n}\n\n.facts {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 2px;\n  font-size: 14px;\n  line-height: 1.4286;\n  color: #71717a;\n}\n\n.dueUrgent {\n  font-weight: 600;\n  color: #991b1b;\n}\n\n.actions {\n  flex-shrink: 0;\n  align-self: center;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.assignButton {\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #18181b;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.assignButton:hover:not(:disabled) {\n  background: #f4f4f5;\n}\n\n.assignButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `HuddleTaskRow-module__row___EAa7E`,
	"checkbox": `HuddleTaskRow-module__checkbox___VIv8e`,
	"checkboxChecked": `HuddleTaskRow-module__checkboxChecked___nBp1w`,
	"checkmark": `HuddleTaskRow-module__checkmark___dsfs5`,
	"linkedIcon": `HuddleTaskRow-module__linkedIcon___wAY2k`,
	"linkedIconGlyph": `HuddleTaskRow-module__linkedIconGlyph___w3noC`,
	"label": `HuddleTaskRow-module__label___NKZtt`,
	"labelText": `HuddleTaskRow-module__labelText___W5MgC`,
	"openChevron": `HuddleTaskRow-module__openChevron___C2Fvu`,
	"title": `HuddleTaskRow-module__title___F6hIR`,
	"titleDone": `HuddleTaskRow-module__titleDone___nidUi`,
	"descriptionDone": `HuddleTaskRow-module__descriptionDone___dwbGQ`,
	"rowOpen": `HuddleTaskRow-module__rowOpen___u3X8i`,
	"titleUrgent": `HuddleTaskRow-module__titleUrgent___FVUpg`,
	"description": `HuddleTaskRow-module__description___JZQWd`,
	"facts": `HuddleTaskRow-module__facts___jCn_q`,
	"dueUrgent": `HuddleTaskRow-module__dueUrgent___C6gjR`,
	"actions": `HuddleTaskRow-module__actions___BVo7d`,
	"assignButton": `HuddleTaskRow-module__assignButton___gTzBO`
};
module.exports = ___CSS_LOADER_EXPORT___;
